(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dv-home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  if (!window.dvHomeBestsellersBound) {
    window.dvHomeBestsellersBound = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-dv-home-bestseller-form]');
      if (!form) return;

      event.preventDefault();

      var button = form.querySelector('[data-dv-home-bestseller-button]');
      var message = form.querySelector('[data-dv-home-bestseller-message]');
      if (!button || button.disabled) return;

      var defaultLabel = button.dataset.label || button.textContent.trim();
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      message.classList.remove('is-error');
      message.textContent = '';

      try {
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!addResponse.ok) throw new Error('cart-add-failed');

        var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('cart-read-failed');

        var cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemCount: cart.item_count, cart: cart }
        }));

        button.textContent = 'Hinzugefügt';
        var cartLink = document.createElement('a');
        cartLink.href = '/cart';
        cartLink.textContent = 'Zum Warenkorb';
        message.textContent = 'Im Warenkorb. ';
        message.appendChild(cartLink);

        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = defaultLabel;
        }, 2200);
      } catch (error) {
        button.disabled = false;
        button.textContent = defaultLabel;
        message.classList.add('is-error');
        message.textContent = 'Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dv-home-ritual-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!window.dvHomeSpotlightBound) {
    window.dvHomeSpotlightBound = true;

    document.addEventListener('submit', async function (event) {
      var form = event.target.closest('[data-dv-home-spotlight-form]');
      if (!form) return;

      event.preventDefault();

      var button = form.querySelector('[data-dv-home-spotlight-button]');
      var message = form.querySelector('[data-dv-home-spotlight-message]');
      if (!button || button.disabled) return;

      var defaultLabel = button.dataset.label || button.textContent.trim();
      button.disabled = true;
      button.textContent = 'Wird hinzugefügt …';
      message.classList.remove('is-error');
      message.textContent = '';

      try {
        var addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!addResponse.ok) throw new Error('cart-add-failed');

        var cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('cart-read-failed');

        var cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { itemCount: cart.item_count, cart: cart }
        }));

        button.textContent = 'Hinzugefügt';
        message.textContent = 'Im Warenkorb. ';
        var cartLink = document.createElement('a');
        cartLink.href = '/cart';
        cartLink.textContent = 'Zum Warenkorb';
        message.appendChild(cartLink);

        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = defaultLabel;
        }, 2200);
      } catch (error) {
        button.disabled = false;
        button.textContent = defaultLabel;
        message.classList.add('is-error');
        message.textContent = 'Das Produkt konnte nicht hinzugefügt werden. Bitte versuche es erneut.';
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
